// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"11f2893b","186":"4e632217","225":"6319b322","344":"6eed59e5","372":"49934a80","377":"d4ee68a5","443":"55bc04d9","738":"c8b8dbe8","841":"0c3042df","856":"eee95040"}[chunkId] + ".chunk.js";
};